import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ReferenceParams, Res, UserRoleReference } from 'src/app/models';
import { ApiUsersService, LanguageService, NotificationService, ValidatorsService } from 'src/app/services';
import { EmployeeInvitationValidator } from './employee-invitation.validators';

@Component({
  selector: 'app-employee-invitation',
  templateUrl: './employee-invitation.component.html',
  styleUrls: ['./employee-invitation.component.css']
})
export class EmployeeInvitationComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  errorMessages: any;
  uroles: UserRoleReference[];
  org_id: string;
  departments: any;
  positions: any;


  form: UntypedFormGroup = this.fb.group({
    org_id: [null],
    email: [null, this.validator.email],
    position_id: [null],
    department_id: [null],
    full_name: [null, this.validator.full_name],
    urole_id: [null, this.validator.urole_id]
  });

  @Input() set data(value) {

    if (value != null) {

      this.form.controls.org_id.setValue(value.org_id);
      this.org_id = value.org_id;
    }
  }

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private apiUsers: ApiUsersService,
    private notification: NotificationService,
    public activeModal: NgbActiveModal,
    private validator: EmployeeInvitationValidator,
    private validatorService: ValidatorsService
  ) { }

  ngOnInit() {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.getRoles();
    this.getPositions();
    this.getDepartments();

    this.form.get('department_id').valueChanges.subscribe(val => {

      this.getPositions(val);
    })

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
  getRoles(): void {

    let params: ReferenceParams = {
      ref_name: 'uroles_in_orgs',
      filter: {
        org_id: this.org_id
      }
    }

    this.subscriptions.add(
      this.apiUsers.getReferences(params, params.ref_name).subscribe((response: Res) => {

        if (response != null) {

          this.uroles = response.result;
        }
      })
    );
  }

  /**
   * 
   */
  getDepartments(): void {

    this.progressRef.start();
    this.loading = true;

    let params = {
      "filter": {
        name: ''
      }
    }

    this.subscriptions.add(
      this.apiUsers.getReferences(params, 'orgs_departments').subscribe((response: Res) => {

        if (response != null) {

          this.departments = response.result;
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }


  /**
   * 
   */
  getPositions(data: string = ''): void {

    this.progressRef.start();
    this.loading = true;

    this.positions = [];


    let params = {
      filter: {
        department_id: data
      }
    }

    this.subscriptions.add(
      this.apiUsers.getReferences(params, 'orgs_positions').subscribe((response: Res) => {

        if (response != null) {

          this.positions = response.result;
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }



   /**
    * 
    */
   onSend(): void {

    this.subscriptions.add(
      this.apiUsers.sendInvitationToEmployee(this.form.value).subscribe((response: Res) => {
        console.log('[RESPONSE] sendInvitation:', response);


        if (response != null) {

          this.notification.show('success', 'Приглашение успешно отправлено!');
          this.activeModal.close(true);
        }
      })
    );
  }

  /**
  * 
  * @param field 
  * @param type 
  */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }

}
